module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921094149_T.a887387b.jpg";